import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";


async function dataStream(callback) {
  const brands = [{id:1,label:'USD',value:"USD"},{id:2,label:'GBP',value:"GBP"},{id:3,label:'SEK',value:"SEK"},{id:3,label:'EUR ',value:"EUR "}]
  // await BrandController.getBrands(country);
  callback(sortArrayPipe.transform(brands, 'value'));
}
const CurrencySelect = withBaseSelect([], dataStream);
export default CurrencySelect;
